<div class="modal">
    <ng-container *ngIf="!selectionVideo; else videoSelected">
        <div class="header">
            <h1>{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_ADD_IMAGE_VIDEO' | translate}}</h1>
        </div>
        <div class="body">
            <div class="section media-selection-section">
                <div class="section-row">
                    <div class="section-column image-container">
                        <input type="file" class="image-input" (change)="addBackgroundImage($event.target.files); this.value=null;">
                        <div class="icon-smash_image icon"></div>
                        <span class="subtitle" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_IMAGE</span>
                    </div>
                    <div class="section-column video-container" (click)="displaySelectionVideo(); $event.stopPropagation()">
                        <div class="icon-smash_videos icon"></div>
                        <span class="subtitle" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_VIDEO</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #videoSelected>
        <div class="header">
            <h1>{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_ADD_VIDEO' | translate}}</h1>
        </div>
        <div class="body">
            <div class="description">
                <span class="text" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_COPY_VIDEO_LINK</span>
            </div>
            <div class="section">
                <div class="form-section">
                    <div class="form-input">
                        <app-smash-input type="text" borderStyle="full"
                            placeholder="{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_INPUT_VIDEO_URL_PLACEHOLDER' | translate}}" [(ngModel)]="url"
                            [error]='error'>
                        </app-smash-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <button class="btn-new white" (click)="hideSelectionVideo($event)">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL' |
                translate}}</button>
            <button class="btn-new red" (click)="addBackgroundVideo(url)" [disabled]="!url">{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_BUTTON_LABEL_SAVE' |
                translate}}</button>
        </div>
    </ng-template>
</div>